// extracted by css-extract-rspack-plugin
export default {"description":"EmployeeFieldGroupPermissionForm__description--i0Jb7"};